import { StandaloneAdunit } from '@/components/content/Adunit';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorAdunit: LabradorComponent = ({ type, data, meta }) => {
  return <StandaloneAdunit data={data} title={'Annons'} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorAdunit;
